export const deslugify = (str: string): string => 
  str
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, (match) => match.toUpperCase()); 

export const getDefaultCollectionName = (userId: string) => {
  return `default-${userId}`
}    